import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CsvLanguageInterceptor implements HttpInterceptor {
  private readonly _translate = inject(TranslateService);
  private readonly csvUrls = [
    '/api/v1/admin/reports/csv/main-statistic',
    '/api/v1/admin/reports/csv/player-statistic',
    '/api/v1/admin/reports/csv',
    '/api/v1/reports/advertisers/csv/',
    '/api/v1/reports/webmaster/csv',
    '/api/v1/reports/webmaster/csv/main-statistic',
    '/api/v1/reports/webmaster/csv/player-statistic',
  ];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const shouldIntercept = this.csvUrls.some(url => req.url.includes(url));

    if (shouldIntercept) {
      const cloned = req.clone({
        setHeaders: {
          'Accept-Language': this._translate.currentLang,
        },
      });

      return next.handle(cloned);
    }

    return next.handle(req);
  }
}
